/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Vue from 'vue';
import VinlocityRegistation from "./Registation";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import { VueShowdown } from "vue-showdown";
import AddressAutoComplete from '../../Components/AddressAutoComplete';
import PhoneValidation from '../../Components/PhoneValidation';


Vue.component("VinlocityRegistation", VinlocityRegistation);
Vue.component('AddressAutoComplete', AddressAutoComplete);
Vue.component('PhoneValidation', PhoneValidation);
Vue.component("TermsAndConditionsModal", TermsAndConditionsModal);
Vue.component("VueShowdown", VueShowdown);


new Vue({
    el: ".vinlocity-registation"
});
